import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import ReduxToastr from 'react-redux-toastr';
import Login from '../Modules/Login/container';
import Navigation from '../Modules/Navigation/container';
import Orders from '../Modules/Orders/container';
import OrderDetails from '../Modules/OrdersDetails/container';
import PaymentDetails from '../Modules/PaymentDetails/container';
import OrderSearch from '../Modules/OrderSearch/container';
// import ProductDetails from '../Modules/ProductDetails/container';
import ManufactureVarients from '../Modules/ManufactureVariants/container';
import MyOrganization from '../Modules/MyOrganization/container'
import SalesInventory from '../Modules/Sales&Inventory/container'

import ActiveUser from '../Modules/MyOrganization/activeuser';
import AddUser from '../Modules/MyOrganization/addUser';
import VendingMachine from '../Modules/VMs/container';
import VendingMachineDetails from '../Modules/VMDetails/container';
import VendingMachineReporting from '../Modules/Reporting/container';
import UploadCashback from '../Modules/UploadCashBackFile/component';
import Permissions from '../Modules/Permissions/container';
// import FutureOrders from '../Modules/FutureOrders/container';
import AuthenticatedRoute from '../Modules/HOC/AuthenticatedRoute/component';
import CreateProduct from '../Modules/CreateNewProduct/container';
import ProductActions from '../Modules/ProductActions/component';
import UpdateProduct from '../Modules/UpdateProducts/container';
import UpdateVariants from '../Modules/UpdateVariants/container';
import CreateVariant from '../Modules/CreateNewVariant/container';
import CreateManufacturerVariant from '../Modules/CreateNewManufacturerVariant/container';
import UpdateManufacturerVariant from '../Modules/UpdateManufacturerVariant/container';
import DownloadCSV from '../Modules/DownloadCSV/container';
import ListVMByMVId from '../Modules/ListVMForVariantID/container';
import UserList from '../Modules/UsersList/container';
import UserCreate from '../Modules/UsersCreate/container';
import UserAssignVM from '../Modules/UsersAssignVM/container';
import UserAssignMF from '../Modules/UsersAssignMF/container';
import VMCohortCreate from '../Modules/VMCohortCreate/container';
import VMCohortListing from '../Modules/VMCohortList/container';
import VMCohortDetails from '../Modules/VMCohortDetails/container';
import VMCreate from '../Modules/VMCreate/container';
import VMPGCreate from '../Modules/VMPGMapping/container';
import ImageList from '../Modules/ImageList/container';
import CreateImage from '../Modules/CreateImage/container';
import UpdateImage from '../Modules/UpdateImage/container';
import VMPaymentList from '../Modules/VMPaymentList/container';
import UserSearch from '../Modules/UserSearch/container';

/* eslint-disable */
require('!style-loader!css-loader!react-redux-toastr/lib/css/react-redux-toastr.min.css');
require('!style-loader!css-loader!./react-datetime.css');
/* eslint-enable */

const Home = () => (
  <div>
    <Helmet>
      <title>Welcome to Daalchini </title>
    </Helmet>
    <h1>Welcome</h1>
  </div>
);

export default function  App() {
  return (
    <div>
      <Switch>
        <Route exact path="/" component={Login} />
        <div>
          <Navigation />
          <AuthenticatedRoute exact path="/home" component={Home} />
          <AuthenticatedRoute exact path="/orders" component={Orders} />
          <AuthenticatedRoute exact path="/orders/details/:orderId" component={OrderDetails} />
          <AuthenticatedRoute
            exact
            path="/orders/:orderId/payment/details"
            component={PaymentDetails}
          />
          <AuthenticatedRoute exact path="/orders_search" component={OrderSearch} />
          <AuthenticatedRoute exact path="/products/actions" component={ProductActions} />
          <AuthenticatedRoute exact path="/products" component={ManufactureVarients} />
          <AuthenticatedRoute exact path="/myorganization" component={MyOrganization} />
          <AuthenticatedRoute exact path="/sales&inventory" component={SalesInventory} />
          
          
		  <AuthenticatedRoute exact path="/myorganization/active-user" component={ActiveUser} />
		  <AuthenticatedRoute exact path="/myorganization/add-new-user" component={AddUser} />
		  <AuthenticatedRoute exact path="/myorganization/add-new-user/bulk-add" component={AddUser} />
		  
          <AuthenticatedRoute
            exact
            path="/products/:productId/vendingmachines"
            component={ListVMByMVId}
          />
          <AuthenticatedRoute exact path="/vendingmachines" component={VendingMachine} />
          <AuthenticatedRoute exact path="/vendingmachines/new" component={VMCreate} />
          <AuthenticatedRoute exact path="/vendingmachines/pg/new" component={VMPGCreate} />
          <AuthenticatedRoute exact path="/vendingmachines/pg/options" component={VMPaymentList} />
          <AuthenticatedRoute exact path="/vendingmachines/rc/screensaver" component={ImageList} />
          <AuthenticatedRoute exact path="/vendingmachines/rc/screensaver/new" component={CreateImage} />
          <AuthenticatedRoute exact path="/vendingmachines/rc/screensaver/update/:imageId" component={UpdateImage} />
          <AuthenticatedRoute
            exact
            path="/vendingmachines/cohorts/new"
            component={VMCohortCreate}
          />
          <AuthenticatedRoute
            exact
            path="/vendingmachines/cohorts/list"
            component={VMCohortListing}
          />
          <AuthenticatedRoute
            exact
            path="/vendingmachines/cohorts/:cohortId/details"
            component={VMCohortDetails}
          />
          <AuthenticatedRoute
            exact
            path="/vendingmachines/:vmId/details"
            component={VendingMachineDetails}
          />
          <AuthenticatedRoute
            exact
            path="/vendingmachines/:vmId/reporting"
            component={VendingMachineReporting}
          />
          <AuthenticatedRoute exact path="/products/new" component={CreateProduct} />
          <AuthenticatedRoute exact path="/products/update" component={UpdateProduct} />
          <AuthenticatedRoute exact path="/products/variants" component={CreateVariant} />
          <AuthenticatedRoute exact path="/products/variants/update" component={UpdateVariants} />
          <AuthenticatedRoute exact path="/products/mvs" component={CreateManufacturerVariant} />
          <AuthenticatedRoute
            exact
            path="/products/mvs/update"
            component={UpdateManufacturerVariant}
          />
          <AuthenticatedRoute exact path="/upload_cashback" component={UploadCashback} />
          <AuthenticatedRoute exact path="/permissions" component={Permissions} />
          <AuthenticatedRoute exact path="/downloads" component={DownloadCSV} />
          <AuthenticatedRoute exact path="/users/list" component={UserList} />
          <AuthenticatedRoute exact path="/users/new" component={UserCreate} />
          <AuthenticatedRoute exact path="/users/vms" component={UserAssignVM} />
          <AuthenticatedRoute exact path="/users/mfs" component={UserAssignMF} />
          <AuthenticatedRoute exact path="/users/search" component={UserSearch} />
          
        </div>
      </Switch>
      <ReduxToastr
        newestOnTop={false}
        preventDuplicates
        position="top-right"
        transitionIn="fadeIn"
        transitionOut="fadeOut"
      />
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/app/App.jsx